import { HandOffPortal } from "../../__generated__/graphql";

/** Whether a partner has Zing (VersePayorHandoff) access, and can use the "place new order" flow. */
export function canAccessPlaceNewOrder(
  accessiblePortals: HandOffPortal[],
): boolean {
  return accessiblePortals.includes(HandOffPortal.VersePayorHandoff);
}

export const dateFormat = new Intl.DateTimeFormat("en", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
});

export const dateTimeFormat = new Intl.DateTimeFormat("en", {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

/** Returns a record's public ref, throwing if the API returned none. */
export function requireRef(ref: string | null | undefined): string {
  if (!ref) {
    throw new Error("Expected a ref but none was returned.");
  }
  return ref;
}

/** Parses JSON error payloads from {@link UPDATE_HAND_OFF_PORTAL_ORDER_STATUS} failures. */
export function getUpdateHandOffPortalOrderErrorMessage(
  errorMsg: string,
): string {
  try {
    const errorObj = JSON.parse(errorMsg) as Record<string, unknown>;
    return String(Object.values(errorObj)[0] ?? "");
  } catch {
    return "Something went wrong processing your request. Please contact Verse Medical for assistance. We apologize for the inconvenience.";
  }
}

export const getDaysDifferenceString = (a: Date, b: Date) => {
  const differenceInDays = Math.floor(
    Math.abs(a.getTime() - b.getTime()) / (1000 * 60 * 60 * 24),
  );
  return `${differenceInDays} ${differenceInDays === 1 ? "day" : "days"} ${a < b ? "after" : "before"}`;
};
